const actions = {
  // MADA BANK RECONCILIATION ACTIONS
  LIST_MADA_BANK_BATCHES_BEGIN: 'LIST_MADA_BANK_BATCHES_BEGIN',
  LIST_MADA_BANK_BATCHES_SUCCESS: 'LIST_MADA_BANK_BATCHES_SUCCESS',
  LIST_MADA_BANK_BATCHES_ERR: 'LIST_MADA_BANK_BATCHES_ERR',

  UPLOAD_MADA_BANK_REPORT_BEGIN: 'UPLOAD_MADA_BANK_REPORT_BEGIN',
  UPLOAD_MADA_BANK_REPORT_SUCCESS: 'UPLOAD_MADA_BANK_REPORT_SUCCESS',
  UPLOAD_MADA_BANK_REPORT_ERR: 'UPLOAD_MADA_BANK_REPORT_ERR',

  GET_MADA_BANK_BATCH_BEGIN: 'GET_MADA_BANK_BATCH_BEGIN',
  GET_MADA_BANK_BATCH_SUCCESS: 'GET_MADA_BANK_BATCH_SUCCESS',
  GET_MADA_BANK_BATCH_ERR: 'GET_MADA_BANK_BATCH_ERR',

  LIST_MADA_BANK_SETTLEMENTS_BEGIN: 'LIST_MADA_BANK_SETTLEMENTS_BEGIN',
  LIST_MADA_BANK_SETTLEMENTS_SUCCESS: 'LIST_MADA_BANK_SETTLEMENTS_SUCCESS',
  LIST_MADA_BANK_SETTLEMENTS_ERR: 'LIST_MADA_BANK_SETTLEMENTS_ERR',

  LIST_MADA_APPROVED_NOT_SETTLED_BEGIN: 'LIST_MADA_APPROVED_NOT_SETTLED_BEGIN',
  LIST_MADA_APPROVED_NOT_SETTLED_SUCCESS: 'LIST_MADA_APPROVED_NOT_SETTLED_SUCCESS',
  LIST_MADA_APPROVED_NOT_SETTLED_ERR: 'LIST_MADA_APPROVED_NOT_SETTLED_ERR',

  GET_MADA_DISCREPANCY_SUMMARY_BEGIN: 'GET_MADA_DISCREPANCY_SUMMARY_BEGIN',
  GET_MADA_DISCREPANCY_SUMMARY_SUCCESS: 'GET_MADA_DISCREPANCY_SUMMARY_SUCCESS',
  GET_MADA_DISCREPANCY_SUMMARY_ERR: 'GET_MADA_DISCREPANCY_SUMMARY_ERR',

  listMadaBankBatchesBegin: () => {
    return { type: actions.LIST_MADA_BANK_BATCHES_BEGIN };
  },
  listMadaBankBatchesSuccess: (data) => {
    return { type: actions.LIST_MADA_BANK_BATCHES_SUCCESS, data };
  },
  listMadaBankBatchesErr: (err) => {
    return { type: actions.LIST_MADA_BANK_BATCHES_ERR, err };
  },

  uploadMadaBankReportBegin: () => {
    return { type: actions.UPLOAD_MADA_BANK_REPORT_BEGIN };
  },
  uploadMadaBankReportSuccess: (data) => {
    return { type: actions.UPLOAD_MADA_BANK_REPORT_SUCCESS, data };
  },
  uploadMadaBankReportErr: (err) => {
    return { type: actions.UPLOAD_MADA_BANK_REPORT_ERR, err };
  },

  getMadaBankBatchBegin: () => {
    return { type: actions.GET_MADA_BANK_BATCH_BEGIN };
  },
  getMadaBankBatchSuccess: (data) => {
    return { type: actions.GET_MADA_BANK_BATCH_SUCCESS, data };
  },
  getMadaBankBatchErr: (err) => {
    return { type: actions.GET_MADA_BANK_BATCH_ERR, err };
  },

  listMadaBankSettlementsBegin: () => {
    return { type: actions.LIST_MADA_BANK_SETTLEMENTS_BEGIN };
  },
  listMadaBankSettlementsSuccess: (data) => {
    return { type: actions.LIST_MADA_BANK_SETTLEMENTS_SUCCESS, data };
  },
  listMadaBankSettlementsErr: (err) => {
    return { type: actions.LIST_MADA_BANK_SETTLEMENTS_ERR, err };
  },

  listMadaApprovedNotSettledBegin: () => {
    return { type: actions.LIST_MADA_APPROVED_NOT_SETTLED_BEGIN };
  },
  listMadaApprovedNotSettledSuccess: (data) => {
    return { type: actions.LIST_MADA_APPROVED_NOT_SETTLED_SUCCESS, data };
  },
  listMadaApprovedNotSettledErr: (err) => {
    return { type: actions.LIST_MADA_APPROVED_NOT_SETTLED_ERR, err };
  },

  getMadaDiscrepancySummaryBegin: () => {
    return { type: actions.GET_MADA_DISCREPANCY_SUMMARY_BEGIN };
  },
  getMadaDiscrepancySummarySuccess: (data) => {
    return { type: actions.GET_MADA_DISCREPANCY_SUMMARY_SUCCESS, data };
  },
  getMadaDiscrepancySummaryErr: (err) => {
    return { type: actions.GET_MADA_DISCREPANCY_SUMMARY_ERR, err };
  },
};

export default actions;
